import React from "react";

function NotificationLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="9"
      viewBox="0 0 21 9"
      fill="none"
    >
      <g clipPath="url(#clip0_2853_7419)">
        <path d="M9.78753 2.71875H8.5V6.55717H9.78753V2.71875Z" fill="white" />
        <path
          d="M9.14472 0.905029C8.70384 0.905029 8.34375 1.20043 8.34375 1.56147C8.34375 1.92423 8.70384 2.21963 9.14472 2.21963C9.58561 2.21963 9.9457 1.92423 9.9457 1.56147C9.9457 1.20043 9.58561 0.905029 9.14472 0.905029Z"
          fill="white"
        />
        <path
          d="M8.01648 2.71865H6.72895C6.70084 3.40272 6.23712 4.06952 5.68206 4.14899V1.35913H4.39453V6.55707H5.68206V5.13537C6.28104 5.1751 6.70084 5.87299 6.72895 6.55707H8.01648C8.00418 6.0872 7.8461 5.56723 7.59667 5.18374C7.44034 4.94189 7.16457 4.79851 6.87298 4.79851H6.47601L6.47425 4.53421H6.89406C7.16632 4.53421 7.42629 4.41156 7.58438 4.19563C7.93568 3.72057 8.00945 3.0935 8.01648 2.71865Z"
          fill="white"
        />
        <path
          d="M20.799 2.71875H19.5132V4.80034C19.5132 5.0992 19.4271 5.51552 18.9371 5.51552C18.577 5.51552 18.2836 5.31513 18.2836 4.87635V2.71875H16.9961V5.09401C16.9961 6.10631 17.5757 6.65219 18.4505 6.65219C19.4605 6.65219 19.5009 5.75736 19.5009 5.75736L19.6924 5.75563L19.6959 5.99921C19.6959 6.50017 19.4183 7.07196 18.4083 7.07196C17.7373 7.07196 17.3211 6.87676 17.3211 6.87676V7.95297C17.3211 7.95297 17.7988 8.276 18.5647 8.276C20.3001 8.276 20.7972 7.03741 20.7972 5.9111V2.71875H20.799Z"
          fill="white"
        />
        <path
          d="M1.7777 3.80537C1.7777 3.66371 1.88309 3.55143 2.08685 3.55143C2.30641 3.55143 2.44167 3.69135 2.44167 3.94702H3.84864C3.84864 2.87599 2.85269 2.62378 2.1132 2.62378C1.13306 2.62378 0.402344 3.06083 0.402344 3.74836C0.402344 5.25643 2.52071 4.75374 2.52071 5.43091C2.52071 5.61747 2.35735 5.7073 2.1536 5.7073C1.79351 5.7073 1.76014 5.44646 1.76014 5.33935H0.4041C0.4041 6.32401 1.28763 6.65223 2.15887 6.65223C3.29885 6.65223 3.92593 6.248 3.92593 5.45509C3.92417 4.11976 1.7777 4.5499 1.7777 3.80537Z"
          fill="white"
        />
        <path
          d="M16.3774 1.35913H15.0898V6.55707H16.3774V1.35913Z"
          fill="white"
        />
        <path
          d="M13.0682 2.62378C12.0792 2.62378 11.8878 3.52206 11.8878 3.52206H11.7016V2.71879H10.4141V7.91673H11.6981H11.7016V5.75567H11.8966C11.8966 5.75567 11.937 6.65395 13.0102 6.65395C13.9183 6.65395 14.628 5.87832 14.628 4.657C14.628 3.63607 14.2204 2.62378 13.0682 2.62378ZM12.5518 5.4931C12.1442 5.4931 11.8123 5.10787 11.8123 4.63627C11.8123 4.16295 12.1442 3.77945 12.5518 3.77945C12.9593 3.77945 13.2912 4.16468 13.2912 4.63627C13.2912 5.1096 12.9593 5.4931 12.5518 5.4931Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2853_7419">
          <rect
            width="20.3932"
            height="7.37627"
            fill="white"
            transform="translate(0.402344 0.89624)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NotificationLogo;
